module.exports = __webpack_public_path__ + "img/notes_empty.07ea02d6.svg";